// core version + navigation, pagination modules:
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

let i = 0;
document.querySelectorAll('.event-swiper').forEach(el => {
  i++;
  let next = el.parentElement.parentElement.querySelector('.swiper-button-next');
  let prev = el.parentElement.parentElement.querySelector('.swiper-button-prev');
  el.classList.add('event-swiper-' + i);
  next.classList.add('event-btn-next-' + i);
  prev.classList.add('event-btn-prev-' + i);

  let eventSwiper = new Swiper('.event-swiper-' + i, {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    // Optional parameters
    // Responsive breakpoints

    breakpoints: {
      // when window width is >= 320px
      767: {
        slidesPerView: 1,
        spaceBetween: 10
      },
      // when window width is >= 992px
      992: {
        slidesPerView: 2,
        spaceBetween: 10
      },
      // when window width is >= 1200px
      1200: {
        slidesPerView: 3,
        spaceBetween: 10
      }
    },
    loop: false,
    // Navigation arrows
    navigation: {
      nextEl: '.event-btn-next-' + i,
      prevEl: '.event-btn-prev-' + i,
    }
  })
})
